var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"d-flex align-items-center justify-content-center rounded-circle mark",class:[_vm.status, _vm.value.type],attrs:{"mark-interaction-component":""},on:{"click":_vm.handleClick}},[_c('i',{staticClass:"far",class:_vm.iconClass})])
}
var staticRenderFns = []

export { render, staticRenderFns }